import AxiosConfig from '../config/axios-config'

export default {

  listarMeusCursos () {
    return AxiosConfig.secureJalekoAPI().get('/cursos/meus').then(response => response.data)
  },

  listarContinuacaoMeusCursos () {
    return AxiosConfig.secureJalekoAPI().get('/cursos/continuarCurso', {
      params: {
        dataCancelamento: 1
      } }).then(response => response.data)
  },

  listarCursosNovos (plano) {
    return AxiosConfig.secureJalekoAPI().get(`/cursos/novos`, { params: { planoUsuario: plano } }).then(response => response.data.data)
  },

  listarCursosIndicados () {
    return AxiosConfig.secureJalekoAPI().get('/cursos/indicados').then(response => response.data)
  },

  listarCursosFavoritos () {
    return AxiosConfig.secureJalekoAPI().get('/cursos/favoritos').then(response => response.data)
  },

  obterInformacaoCurso (referencia) {
    return AxiosConfig.secureJalekoAPI().get(`/curso/${referencia}/info`).then(response => response.data)
  },

  obterDetalheEmenta: function (referenciaCurso) {
    return AxiosConfig.secureJalekoAPI().get(`/curso/${referenciaCurso}/ementa`, {
      params: {
        dataCancelamento: 1
      } }).then(response => response.data)
  },

  obterResumoQuantitativo: function (referenciaCurso) {
    return AxiosConfig.secureJalekoAPI().get(`/resumocurso/${referenciaCurso}`).then(response => response.data)
  },

  listarModulosPorCurso: function (referenciaCurso) {
    return AxiosConfig.secureJalekoAPI().get(`/curso/${referenciaCurso}/modulo/`).then(response => response.data)
  },

  listarLicoesPorModulo: function (referenciaCurso, referenciaModulo) {
    return AxiosConfig.secureJalekoAPI().get(`/curso/${referenciaCurso}/modulo/${referenciaModulo}/licao`).then(response => response.data)
  }

}
